import { RootState } from '@/app/store';
import { logout, setTokens } from '@/entities/authSlice';
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { getAcceptLang } from './getAcceptLang';
import { refreshTokens } from './refresh';

const baseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_API_URL}/exec/api`,
  // paramsSerializer: (params) => {
  //   const p = Object.entries(params).filter((val) => !!val[1]);
  //   return qs.stringify(p, { skipNulls: true });
  // },
  prepareHeaders: (headers, { getState, endpoint }) => {
    const token = (getState() as RootState).auth.token;
    const userKey = (getState() as RootState).auth.userKey;
    const acceptLang = getAcceptLang() || 'ru';

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    if (acceptLang) {
      headers.set('accept-language', acceptLang);
    }

    if (
      userKey &&
      (endpoint === 'deleteFactorLimit' ||
        endpoint === 'signDealDocument' ||
        endpoint === 'createPaymentsDocument')
    ) {
      headers.set('user-key', userKey);
    }

    return headers;
  },
});

export const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error?.status !== 401) return result;

  const refreshToken = (api.getState() as RootState).auth.refreshToken;

  if (!refreshToken) return result;

  const tokens = await refreshTokens(refreshToken);

  if (!tokens) {
    api.dispatch(logout());
    return result;
  }

  api.dispatch(setTokens(tokens));

  return baseQuery(args, api, extraOptions);
};
